module.exports = __webpack_public_path__ + "img/account.bd2b6765.jpg";